import '../styles/Hero.css'
import hero1 from '../assets/hero1.png'
import mtn from '../assets/mtn.svg'
import airtel from '../assets/airtel.svg'
import glo from '../assets/glo.svg'
import nine_mobile from '../assets/nine_mobile.svg'

// import 'aos/dist/aos.css';

import { useAuth } from '../context/authContext.jsx';
import { useNavigate, Link } from 'react-router-dom';
import { auth } from '../firebase/firebaseConfig';
import { signOut } from 'firebase/auth';

function Hero({onSignInClick, onSignUpClick}) {
    const { userLoggedIn } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async (e) => {
        e.preventDefault();
        await signOut(auth);
        alert("User logged out successfully!");
        navigate('/');
    };

    return ( 
        <section className = 'hero-section p-4 lg:p-10 sm:p-4 text-dark2 dark:text-light1' id='hero-section' >
            <div className = 'hero-div flex-col lg:flex-row  md:flex-col sm:flex-col ' >
                <div className = 'hero-content  lg:my-8 mt-0 flex flex-col items-start justify-start left-0 !ml-0 !pl-0 space-y-5 ' >
                    <h1 className = ' text-3xl font-semibold md:text-4xl lg:text-5xl' data-aos="fade-down" data-aos-duration="1000"> Welcome To Jcoteck VTU </h1>  
                    <h3 className=' text-lg md:text-2xl lg:text-3xl' data-aos="fade-right" data-aos-duration="1200"> Your Seamless and Affordable data Plug </h3> 
                    <span className=' text-lg text-dark0 md:text-xl lg:text-2xl' data-aos="fade-right" data-aos-duration="1200"> ....stay connected with Jcoteck VTU </span> 
                    <div className = 'hero-btn-container' >
                        {userLoggedIn ? (
                            <>
                                <Link to="/account"><button className='btn' data-aos="fade-up" data-aos-duration="1500"> Account </button></Link>
                                <button className='hero-btn' data-aos="fade-up" data-aos-duration="1500" onClick={handleLogout}> Sign Out </button>
                            </>
                        ) : (
                            <>
                                <button className='btn' data-aos="fade-up" data-aos-duration="1500" onClick={onSignInClick}> Sign In </button>
                                <button className='hero-btn' data-aos="fade-up" data-aos-duration="1500" onClick={onSignUpClick}> Sign Up </button>
                            </>
                        )}
                    </div> 
                </div >

                <div className = 'hero-img-container md:mr-0 md:p-0' >
                    <div className = 'img-circle relative ' data-aos="fade-left" data-aos-duration="1000">                
                        <img className = 'hero-img'
                        src = { hero1 }
                        data-aos="fade-up" data-aos-duration="1500"
                        alt = 'Hero goes here' />

                        <img src = { mtn } data-aos="fade-up" data-aos-duration="1000"
                        className = 'hero-svg-img hero-svg-img1'
                        alt = 'mtn' />
                        <img src = { glo } data-aos="fade-up" data-aos-duration="1500"
                        className = 'hero-svg-img hero-svg-img2'
                        alt = 'glo' />
                        < img src = { airtel } data-aos="fade-up" data-aos-duration="2000"
                        className = 'hero-svg-img hero-svg-img3'
                        alt = 'airtel' />
                        < img src = { nine_mobile } data-aos="fade-up" data-aos-duration="2000"
                        className = 'hero-svg-img hero-svg-img4'
                        alt = '9mobile' />
                    </div> 
                </div>  
            </div >
        </section>
    );
}
export default Hero;